import { RestApplicationClient } from '../generated-types';
class DefaultRestApplicationClient extends RestApplicationClient {
  constructor(httpClient) {
    super(httpClient);
    this.httpClient = httpClient;
    this.httpClient = httpClient;
  }
}
export default DefaultRestApplicationClient;